export const submitMessage = "Are you sure want to submit this form ?";
export const saveMessage = "Are you sure want to save this form ?";